// Global toast notifications (see ui/Toast.svelte, rendered once in
// App.svelte).
export type ToastKind = 'success' | 'error' | 'info';
export interface ToastItem {
  id: number;
  kind: ToastKind;
  text: string;
}

let items = $state<ToastItem[]>([]);
let nextId = 1;

function dismiss(id: number) {
  items = items.filter((i) => i.id !== id);
}

function push(text: string, kind: ToastKind = 'info', durationMs = 5000): number {
  const id = nextId++;
  items = [...items, { id, kind, text }];
  if (durationMs > 0) setTimeout(() => dismiss(id), durationMs);
  return id;
}

export const toast = {
  get items() {
    return items;
  },
  push,
  dismiss,
  success: (text: string) => push(text, 'success'),
  error: (text: string) => push(text, 'error'),
  info: (text: string) => push(text, 'info')
};
